import React from 'react';
import "../../css/Legal.css";

const ShippingDelivery = () => {
    return (
        <div className="legal-container">
            <h1 className="legal-title">Shipping &amp; Delivery Policy</h1>
            <p><strong>Last Updated:</strong> 25<sup>th</sup> July 2025</p>
            <p>At <strong>Craft My Store</strong>, a service operated by <strong>Teraforge Digital Lab LLP</strong>, we specialize in providing <strong>digital services</strong>, specifically <strong>custom-built ecommerce websites, hosting solutions, and related digital deliverables</strong>. This Shipping &amp; Delivery Policy (“<strong>Policy</strong>”) outlines the nature, method, and timeline of delivery of our services.</p>
            <p>While we <strong>do not ship any physical goods</strong>, this Policy is published in compliance with payment gateway guidelines and applicable e-commerce regulations.</p>

            <h2>1. Nature of Our Products and Services</h2>
            <p>Craft My Store exclusively offers <strong>digital services</strong>, which include but are not limited to:</p>
            <ul>
                <li>Ecommerce Website Design &amp; Development</li>
                <li>Website Hosting &amp; Server Management</li>
                <li>Domain Setup Assistance</li>
                <li>Custom Plugin Development</li>
                <li>Technical Support and Maintenance</li>
                <li>Admin Dashboard and Backend Access</li>
            </ul>
            <p>All deliverables are virtual in nature and delivered through <strong>digital means only</strong> — such as cloud servers, email, file sharing, or access credentials.</p>

            <h2>2. Delivery of Digital Services</h2>
            <h3>2.1 Ecommerce Development</h3>
            <p>We build custom ecommerce stores tailored to your business requirements. Given the variability in design scope, feature complexity, third-party integrations, and client feedback cycles:</p>
            <p><strong>No fixed timeline is provided for ecommerce store development.</strong><br />Project completion is subject to collaborative factors including client responsiveness, specification clarity, and scope of features.</p>
            <p>You will be assigned an account manager who will coordinate the project and update you periodically as development progresses.</p>
            <h3>2.2 Hosting Services</h3>
            <p>Hosting setup and configuration will be <strong>initiated within 3–5 business days</strong> <strong>after</strong> we receive:</p>
            <ul>
                <li>Full domain registrar access;</li>
                <li>Required DNS-related configurations or authorization codes;</li>
                <li>Confirmation of the selected hosting plan.</li>
            </ul>
            <p><strong>Note:</strong> Time taken for <strong>DNS propagation</strong>, <strong>domain verification</strong>, or <strong>external registrar delays</strong> is <strong>not included</strong> in the 3–5 day initiation window and may vary by registrar or geographic location.</p>
            <p>Hosting features such as SSL, CDN, and Cloudflare protection will be enabled progressively once domain pointing and nameservers are correctly set.</p>

            <h2>3. Mode of Delivery</h2>
            <p>As we provide 100% digital services, all final deliverables and services are delivered through one or more of the following digital methods:</p>
            <ul>
                <li>Server or Hosting Panel Access</li>
                <li>Admin Credentials for CMS (e.g. WordPress)</li>
                <li>Source Code Upload to Cloud Repo or Hosting</li>
                <li>Shared Documents or Files (via Google Drive, Dropbox, or Email)</li>
                <li>Links to Access Production/Live Websites</li>
                <li>API or Plugin Installation via Remote Support</li>
            </ul>
            <p>You will be notified by email or WhatsApp once your project or milestone is complete and delivered.</p>

            <h2>4. No Physical Shipping</h2>
            <p>We <strong>do not</strong> manufacture, sell, or ship any physical products. Hence:</p>
            <ul>
                <li>No shipping provider (e.g., FedEx, India Post, BlueDart) is used;</li>
                <li>No tracking number or courier ID will be provided;</li>
                <li>No physical logistics or warehouse handling occurs.</li>
            </ul>
            <p>Any indication of “shipping” or “delivery” on our checkout or invoices refers only to the digital delivery of our service.</p>

            <h2>5. Delays &amp; Exceptions</h2>
            <p>While we strive to meet the committed timelines, the following scenarios may impact delivery:</p>
            <ul>
                <li>Delay in receiving required inputs, approvals, or content from the client;</li>
                <li>Technical challenges or third-party API delays (e.g., payment gateway approvals);</li>
                <li>Force majeure events (natural disasters, internet outages, pandemics, etc.);</li>
                <li>Delay in domain access or DNS propagation;</li>
                <li>Change requests made mid-way through the development cycle.</li>
            </ul>
            <p>In all such cases, we will proactively communicate revised timelines.</p>

            <h2>6. Order Status &amp; Communication</h2>
            <p>After you place your order:</p>
            <ul>
                <li>Within 24–48 business hours, a member of our team will reach out to begin onboarding;</li>
                <li>Project updates will be shared via <strong>email</strong>, <strong>WhatsApp</strong>, or through your <strong>assigned account manager</strong>;</li>
                <li>Upon completion, delivery will be confirmed in writing, and access credentials (if applicable) will be shared securely.</li>
            </ul>

            <h2>7. Delivery Completion &amp; Handover</h2>
            <p>A project is considered “<strong>delivered</strong>” or “<strong>shipped</strong>” when:</p>
            <ul>
                <li>The live ecommerce website is deployed on your domain (or staging);</li>
                <li>Admin login credentials are handed over;</li>
                <li>All scope-based deliverables are complete and documented;</li>
                <li>You have acknowledged the handover, or post-launch support begins.</li>
            </ul>
            <p>You are advised to take a full backup of all files and credentials at the time of handover.</p>

            <h2>8. International Customers</h2>
            <p>Our services are available globally. All timelines are in <strong>Indian Standard Time (IST)</strong>, and deliveries will be coordinated across time zones as needed.</p>
            <p>Please note that local holidays in India may affect delivery schedules.</p>

            <h2>9. Contact and Support</h2>
            <p>If you have any questions related to the delivery of your order, please contact us:</p>
            <p><strong>Craft My Store</strong><br />
                <strong> Operated by: </strong>Teraforge Digital Lab LLP<br />
                <strong> Email: </strong>contact@craftmystore.com<br />
                <strong> Phone:</strong> +91 7718837352<br />
                <strong> Website: </strong><a href="https://www.craftmystore.com" target="_blank" rel="noopener noreferrer">https://www.craftmystore.com</a><br />
                <strong>Address: </strong>T6, Lodha Crown, Quality Homes Thane, Near Majiwada Flyover, Thane – 400601, Maharashtra, India
            </p>

            <h2>10. Amendments to This Policy</h2>
            <p>We may update this Policy from time to time to reflect changes in our services or regulatory compliance. All updates will be posted on this page, with the latest revision date indicated at the top. Your continued use of our services constitutes acceptance of the revised policy.</p>
        </div>
    );
};

export default ShippingDelivery;